import React from 'react';

const ML_Languages = () => {
    return (
        <div>ML_Languages Component</div>
    );
}

export default ML_Languages;
